import { object, date } from 'yup'
import moment from 'moment'
import { t } from 'translations'

export const ArticleDetailFormSchema = object({
    validFrom: date().required(() => t('products.validity.form.validFromRequired')).nullable(),
    validTo: date()
        .required(() => t('products.validity.form.validToRequired'))
        .nullable()
        .max(moment().add(4, 'year').toDate(), () => t('products.validity.form.validToMax')),
    showFrom: date().required(() => t('products.validity.form.showFromRequired')).nullable(),
    showTo: date().required(() => t('products.validity.form.showToRequired')).nullable(),
})
